export function applicationHeaderConfig({ colors }) {
    return {
        borderTop: `4px solid ${colors.applicationHeaderHighlight}`
    };
}
